import React, { useEffect, useState } from 'react';
import { TalentBios, useApi } from '@axiom/ui';
import type { User } from '@axiom/validation';
import { useLocation, useParams, useSearchParams } from 'react-router';

import { CandidateApi } from '../../api/candidate-api';
import { EnvUtil } from '../../utils/env-util';
import { WindowUtil } from '../../utils/window-util';
import { TaxonomyApi } from '../../api/taxonomy-api';
import { BioPdfDownload } from '../BioPdfDownload/BioPdfDownload';

export const CandidateBios = ({
  user,
  name,
}: {
  user: User;
  name?: string;
}) => {
  const urlParams = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { candidateId } = urlParams;

  if (!candidateId) {
    throw new Error('candidateId is was not provided');
  }

  const isAnon = location.pathname.includes('/anonymous');
  const download = location.pathname.includes('/download');
  const HIDE_HIGHLIGHTS = searchParams.get('hideHighlights');
  const HIDE_LOCATION = searchParams.get('hideLocation');

  const [{ data: bioCandidate }, { data: taxonomy }] = useApi(
    CandidateApi.readBio({ candidateId, isAnonymous: isAnon }),
    TaxonomyApi.readTaxonomy()
  );

  const [downloadOptions, setDownloadOptions] = useState<{
    hideHighlights: boolean;
    hideLocation: boolean;
  } | null>(null);

  useEffect(() => {
    WindowUtil.title(bioCandidate.calculatedDisplayName);
  }, [candidateId]);

  const handleOnNavigate = (hideHighlights = false, hideLocation = false) => {
    setDownloadOptions({ hideHighlights, hideLocation });
  };
  return (
    <>
      <TalentBios
        name="TALENT_BIOS"
        isAhqBio
        isDownloading={download}
        candidate={bioCandidate}
        clientUrl={EnvUtil.clientUrl}
        groupedExperiences={bioCandidate.groupedExperiences}
        legalTechSkills={bioCandidate.legalTechSkills}
        taxonomy={taxonomy}
        user={user}
        onNavigate={handleOnNavigate}
        hideAllHighlights={HIDE_HIGHLIGHTS === 'true'}
        hideLocation={HIDE_LOCATION === 'true'}
        isAnonymous={isAnon}
      />
      {downloadOptions ? (
        <BioPdfDownload
          name="BIO_PDF_DOWNLOAD"
          queue={[{ candidateId: bioCandidate.id, isAnonymous: isAnon }]}
          hideAllHighlights={downloadOptions.hideHighlights}
          hideLocation={downloadOptions.hideLocation}
          onComplete={() => {
            setDownloadOptions(null);
          }}
        />
      ) : null}
    </>
  );
};
